// ─────────────────────────────────────────
// ts/whatsapp.ts — Botão flutuante do WhatsApp
// Fica fixo no canto e acompanha o scroll em todas as páginas.
// Tauvior — Hardware, sistemas embarcados e conectividade industrial
// ─────────────────────────────────────────

import { getTranslation, SOCIAL_ICONS } from '../i18n/index';

const FAB_ID = 'whatsapp-fab';

/**
 * O número e o rótulo vêm da mesma entrada que alimenta o ícone do rodapé
 * (`footer.social`, rede `whatsapp`): o link mora em um lugar só, e o
 * rótulo já chega traduzido. Sem href — como no rodapé — o botão não é
 * criado, em vez de virar um destino morto.
 */
export function initWhatsAppFab(): void {
  if (document.getElementById(FAB_ID)) return;

  const wa = getTranslation().footer.social.find((s) => s.network === 'whatsapp');
  if (!wa?.href) return;

  // O balão é o rótulo visível, então é ele que dita o nome acessível —
  // anunciar um texto diferente do que está na tela quebra o comando de voz.
  // Sem `title`: o balão nativo do navegador duplicaria o mesmo texto.
  const name = wa.tooltip ?? wa.label;

  const fab = document.createElement('a');
  fab.id        = FAB_ID;
  fab.className = 'wa-fab';
  fab.href      = wa.href;
  fab.target    = '_blank';
  fab.rel       = 'noopener';
  fab.setAttribute('aria-label', name);
  fab.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">${SOCIAL_ICONS.whatsapp}</svg>`;

  const tip = document.createElement('span');
  tip.className   = 'wa-fab-tip';
  tip.textContent = name;
  tip.setAttribute('aria-hidden', 'true'); // o aria-label já diz o mesmo
  fab.appendChild(tip);

  document.body.appendChild(fab);

  // Entrada no quadro seguinte: sem isso o elemento nasce já no estado
  // final e a transição não chega a rodar.
  requestAnimationFrame(() => fab.classList.add('is-visible'));
}
